<template>
  <ItemDialog ref="DialogLoading" :imageType="isTimeout ? 'alert' : 'loader'">
    <template v-if="isTimeout" v-slot:content-area>
      <p class="text-center">
        動作に時間がかかっています。<br />
        電波の良いところでもう一度お試しください。
      </p>
    </template>
    <template v-if="isTimeout" v-slot:button-area>
      <ItemButton label="閉じる" actionType="btn-primary" @clicked="closeDialog()" />
    </template>
  </ItemDialog>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";

import nativeHandlerService from "@/services/nativeHandler";
import { useStore } from "vuex";
export default {
  name: "DialogLoading",
  props: {
    timeoutSeconds: {
      type: Number,
      required: false,
      default: 60000,
    },
  },
  setup(props) {
    const DialogLoading = ref(null);
    const timer = ref(null);
    const isTimeout = ref(false);
    const store = useStore();
    const openDialog = () => {
      timer.value = setTimeout(timeout, props.timeoutSeconds);
      DialogLoading.value.open();
    };

    const closeDialog = () => {
      if (isTimeout.value) {
        resetDialog();
        store.commit("common/setIsReloadComponent", true);
      } else {
        resetDialog();
      }
    };

    const resetDialog = () => {
      isTimeout.value = false;
      clearTimeout(timer.value);
      DialogLoading.value.close();
    };

    const returnTopPage = () => {
      closeDialog();
      nativeHandlerService.returnNativeAppTopPage();
    };

    const timeout = () => {
      isTimeout.value = true;
    };

    return {
      DialogLoading,
      isTimeout,
      openDialog,
      closeDialog,
      returnTopPage,
    };
  },
};
</script>
